export function isImageFilename(filename: string): boolean {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp']; // Add more extensions if needed
  const splittedFilename = filename.split('.');
  const fileExtension = splittedFilename.pop();
  if (!fileExtension) {
    return false;
  }
  return imageExtensions.includes(fileExtension.toLowerCase());
}

export function removeQueryStringFromUrl(url: string) {
  const urlObject = new URL(url);
  urlObject.search = '';
  urlObject.hash = '';
  return urlObject.toString();
}
